import { render, staticRenderFns } from "./index-default.vue?vue&type=template&id=625e7d61&"
import script from "./index-default.vue?vue&type=script&lang=js&"
export * from "./index-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports